//Core
import React from "react"

//Components

import SwipeableViews from "react-swipeable-views"

//Images
import Carousel_1 from "../../../images/1.png"
import Carousel_2 from "../../../images/2.png"
import Carousel_3 from "../../../images/3.png"
import Carousel_4 from "../../../images/4.png"
import Carousel_5 from "../../../images/5.png"

import Next from "../../../images/next.png"

//Components
import Dots from "./Dots"

//Styles
import style from "./style.module.scss"

const tutorialSteps = [
  {
    imgPath: Carousel_1,
  },
  {
    imgPath: Carousel_2,
  },
  {
    imgPath: Carousel_3,
  },
  {
    imgPath: Carousel_4,
  },
  {
    imgPath: Carousel_5,
  },
]

function SwipeableTextMobileStepper({
  handleNext,
  handleBack,
  handleStepChange,
  activeStep,
}) {
  return (
    <div className={style.carousel}>
      <img
        style={{
          fontSize: "8px",
          transform: "rotate(180deg)",
          zIndex: 100,
        }}
        src={Next}
        onClick={handleBack}
        className={style.arrow}
        alt="Arrow back"
      />
      <div className={style.slide}>
        <SwipeableViews
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {tutorialSteps.map((step, index) => (
            <div key={step.imgPath} className={style.slider}>
              {Math.abs(activeStep - index) <= 2 ? (
                <img
                  className={style.img}
                  src={step.imgPath}
                  alt={"Таскомбанк Apple Pay налаштування"}
                />
              ) : null}
            </div>
          ))}
        </SwipeableViews>
        <Dots activeItem={activeStep} handleOnClick={handleStepChange} />
      </div>
      <img
        style={{
          fontSize: "10px",
          zIndex: 100,
        }}
        src={Next}
        onClick={handleNext}
        className={style.arrow}
        alt="Arrow next"
      />
    </div>
  )
}

export default SwipeableTextMobileStepper
